import { Phone, MessageSquare, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Mobile-only sticky bottom CTA bar.
 * Renders on small screens only. Use on high-bounce landing pages.
 */
export const MobileStickyCTA = () => {
  const navigate = useNavigate();

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-border shadow-[0_-4px_12px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      role="region"
      aria-label="Quick contact"
    >
      <div className="grid grid-cols-3 gap-1 p-2">
        <a
          href="tel:6306869987"
          className="flex flex-col items-center justify-center py-2 px-1 rounded-md bg-orange-500 text-white font-semibold text-xs active:bg-orange-600"
        >
          <Phone className="h-5 w-5 mb-0.5" />
          Call Now
        </a>
        <a
          href="sms:6306869987&body=Hi%20LifeTime%20Movers%2C%20I%27d%20like%20a%20quote%20for%20my%20move."
          className="flex flex-col items-center justify-center py-2 px-1 rounded-md bg-primary text-primary-foreground font-semibold text-xs active:opacity-90"
        >
          <MessageSquare className="h-5 w-5 mb-0.5" />
          Text Us
        </a>
        <button
          onClick={() => navigate("/quote")}
          className="flex flex-col items-center justify-center py-2 px-1 rounded-md bg-secondary text-secondary-foreground font-semibold text-xs active:opacity-90"
        >
          <ArrowRight className="h-5 w-5 mb-0.5" />
          Get Quote
        </button>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
